import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CardGrafico } from './CardGrafico';
import { useChartTheme } from './ChartTheme';
import { fmtBRL, fmtBRLcompacto } from './formatadores';
import type { DashboardFinanceiro } from '../../types';

function curto(nome: string): string {
  const n = (nome || '').trim();
  return n.length > 22 ? `${n.slice(0, 21)}…` : n;
}

export function GraficoTopClientes({ dados }: { dados: DashboardFinanceiro['por_cliente'] }) {
  const t = useChartTheme();
  const data = dados.slice(0, 8).map((d) => ({ ...d, rotulo: curto(d.cliente_nome) }));
  return (
    <CardGrafico titulo="Maiores clientes (receita)" vazio={!data.length} altura={Math.max(260, data.length * 34)}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 4, right: 16, left: 8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={t.grid} horizontal={false} />
          <XAxis type="number" tickFormatter={(v) => fmtBRLcompacto(v as number)} tick={{ fontSize: 11, fill: t.texto }} axisLine={false} tickLine={false} />
          <YAxis type="category" dataKey="rotulo" tick={{ fontSize: 11, fill: t.texto }} axisLine={false} tickLine={false} width={130} />
          <Tooltip
            cursor={{ fill: t.grid, opacity: 0.3 }}
            formatter={(v: number, n) => [fmtBRL(v), n === 'recebido' ? 'Recebido' : 'Total']}
            contentStyle={{ background: t.tooltipBg, border: `1px solid ${t.grid}`, borderRadius: 8, fontSize: 12, color: t.texto }}
          />
          <Bar dataKey="total" fill={t.paleta[0]} radius={[0, 4, 4, 0]} maxBarSize={22} />
          <Bar dataKey="recebido" fill={t.recebido} radius={[0, 4, 4, 0]} maxBarSize={22} />
        </BarChart>
      </ResponsiveContainer>
    </CardGrafico>
  );
}
